import axios from 'axios'

const state = {
    products: []
}

const getters = {
    allProducts: (state) => state.products
}

const actions = {
    async fetchProducts({ commit }) {
        const response = await axios.get("https://tostado.edgarsandoval.mx/api/products")
        
        commit('setProducts', response.data.data.products)
    },
    addProduct({ commit }, product) {
        /* axios call */
        commit('newProduct')
    }
}

const mutations = {
    setProducts: (state, products) => (state.products = products),
    newProduct: (state, product) => state.products.unshift(product)
}

export default {
    state,
    getters,
    actions,
    mutations
}